import { Box, Typography } from "@mui/material";

import RegistrationTracking from "../components/RegistrationTracking";
import AdminGate from "../components/AdminGate";

export function AlainContent() {
  return (
    <Box sx={{ maxWidth: 1400, mx: "auto", px: 3, py: 4 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Suivi des inscriptions
      </Typography>

      <RegistrationTracking />
    </Box>
  );
}

export default function AlainAdmin() {
  return (
    <AdminGate role="club">
      <AlainContent />
    </AdminGate>
  );
}
